/* UI State
========================================================================== */
export const useColumns = () => useState('columns', () => 0);
export const useShowGrid = () => useState('showGrid', () => false);

/* APP State
========================================================================== */
export const useFirstLoad = () => useState('firstload', () => true);
export const useAppLoaded = () => useState('appLoaded', () => false);
export const useTransitioning = () => useState('transitioning', () => false);
export const useMenuOpen = () => useState('menuOpen', () => false);
export const useAboutModal = () => useState('aboutModal', () => false);
export const useMailConfirmModal = () =>
  useState('mailConfirmModal', () => false);

export const useBrandRow = () => useState('brandRow', () => 'center');
export const useFooterVisible = () => useState('footerVisible', () => false);
export const useLoadingProgress = () => useState('loadingProgress', () => 0);
export const useHeaderAnimated = () => useState('headerAnimated', () => false);

/* Data
========================================================================== */
export const useResources = () => useState('resources', () => null);
export const useGlobal = () => useState('global', () => null);

/* Pages
========================================================================== */
